module.exports = __webpack_public_path__ + "img/blank-canvas.ccfd6410.webp";